import { createContext, ReactNode, useState } from 'react';
import { useQuery } from 'react-query';
import { QueryKeys } from '~/api/queryKeys';
import { LoanTypes } from '~/api/scheme';

export type LoanType = 'other' | 'cnv' | 'fha' | 'pp' | 'sba' | 'va' | 'rev';

type LoanTypesContextProps = {
  loanTypes: LoanType[];
  changeLoanTypesState: (types: LoanType[]) => void;
};

// LoanTypes should be sorted in alphabetical order to match the order from api
const defaultTypes: LoanType[] = [
  'other',
  'cnv',
  'fha',
  'pp',
  'sba',
  'va',
  'rev',
].sort() as LoanType[];

const initialState: LoanTypesContextProps = {
  loanTypes: defaultTypes,
  changeLoanTypesState: () => {},
};

const LoanTypesContext = createContext(initialState);

type LoanTypesProviderProps = {
  children: ReactNode;
};

function LoanTypesProvider({ children }: LoanTypesProviderProps) {
  const [loanTypes, setLoanTypes] = useState(defaultTypes);

  const changeLoanTypesState = (types: LoanType[]) => {
    setLoanTypes(types);
  };

  useQuery(QueryKeys.loan_types(), LoanTypes.index, {
    refetchOnWindowFocus: false,
    onSuccess: (data: any) => {
      setLoanTypes(data.data);
    },
  });

  return (
    <LoanTypesContext.Provider value={{ loanTypes, changeLoanTypesState }}>
      {children}
    </LoanTypesContext.Provider>
  );
}

export { LoanTypesProvider, LoanTypesContext };
